import React, { useState } from 'react';
import { CustomCssIconSelected, LayoutUIModelIconSelected, ThemeIconSelected } from "assests/GmsIcons";

type TabButtonProps = {
    id?: string;
    icon: React.ReactNode;
    label: string;
    isActive: boolean;
    onClick: () => void;
    className?: string;
}

export const TabButton = ({ id, icon,  label,  isActive,  onClick,  className = ''}: TabButtonProps) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <button
            id={id}
            data-testid={id}
            className={`
                tw-flex tw-flex-col tw-items-center tw-justify-center
                tw-w-full tw-py-2
                tw-transition-colors tw-duration-200
                ${isActive 
                    ? 'tw-text-[#091CAA] tw-font-semibold' 
                    : `tw-text-[#6D788C] tw-font-normal ${isHovered ? 'hover:tw-text-[#091CAA] hover:tw-font-semibold' : ''}`
                }
                ${className}
            `}
            onClick={onClick}
            title={label}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className={`tw-p-1 tw-rounded-md ${
                isActive
                    ? 'tw-bg-[#EEEEEE]'
                    : isHovered ? 'tw-bg-[#EEEEEE]' : 'tw-bg-white'
            }`}>
                {isActive || isHovered
                    ? getSelectedIcon(label)
                    : icon
                }
            </div>
            <span className="tw-text-xs tw-mt-1">{label}</span>
        </button>
    );
};


const getSelectedIcon = (label: string) => {
    switch(label) {
        case 'Layout':
            return <LayoutUIModelIconSelected />;
        case 'Theme':
            return <ThemeIconSelected />;
        case 'Custom CSS':
            return <CustomCssIconSelected />;
        default:
            return null;
    }
};